<template>
  <div class="progressionEmailComponent">
    <div class="container-fluid">
       <div class="row margin-top-3Perc vertical-align"><!-- first row start -->
           <!-- <div class="text-center margin-bottom-7Perc">
             <h3 class="col-sm-10 col-md-10 col-lg-10">Send Progression Email</h3>
            </div> -->
          <div class="col-sm-1 col-md-1 col-lg-1"></div>
          <div class="col-sm-1 col-md-1 col-lg-1 text-align-right Padding-right-0px">
              <b>Group</b>
          </div>
          <div class="col-sm-4 col-md-4 col-lg-4">
             <select class="form-control" v-model="selectedGroupObj" @change="selectGroup($event)">
                <option value='-1' disabled>Select</option>
                <option v-for="groupObj in GroupList" v-bind:key="groupObj.GroupId" v-bind:value="groupObj">{{ groupObj.GroupName }}</option>             
             </select>
          </div>
          <div class="col-sm-6 col-md-6 col-lg-6">
          </div>
        </div>    <!--end of first row -->    
        <div class="row margin-top-3Perc vertical-align">
          <div class="col-sm-1 col-md-1 col-lg-1"></div>
          <div class="col-sm-1 col-md-1 col-lg-1 text-align-right Padding-right-0px">
            <b>Course</b>
          </div>
          <div class="col-sm-9 col-md-9 col-lg-9">
            <div class="border-1px padding-15px overflow-y-enabled" >
              <div class="leftAlign" > 
                <input type="checkbox" v-model="SelectAllCoursesFlag2" :hidden="CoursesList.length === 0" id="selectAllCoursesCheckBox" @change="selectAllCoursesChecked($event)"/>
                <label class="font-weight-normal" for="selectAllCoursesCheckBox">{{CoursesList.length === 0 ? 'No Course(s)' : 'Select All'}}</label>
              </div> 
              <div class="leftAlign" v-for="(c,index) in CoursesList" :key="index"> 
                <input type="checkbox" :checked="c.isSelected ? 'checked' : ''" :value="c" :id="c.GroupCourseMasterId" :title="c.CourseName" @change="courseCheckListChecked($event)"/>
                <label class="font-weight-normal" :for="c.GroupCourseMasterId">{{ c.CourseTitle }} [{{c.CourseSubTitle}}]</label>
              </div> 
            </div>
          </div>
          <div class="col-sm-1 col-lg-1 col-lg-1"></div>
        </div><!-- end of second row -->

        <div class="row margin-top-3Perc vertical-align" v-if="GroupUserList.length > 0"><!-- first row start -->
          <div class="col-sm-2 col-md-2 col-lg-2 text-align-right Padding-right-0px">
            <b>Upload User(s) via CSV</b>
          </div>
          <div class="col-sm-4 col-md-4 col-lg-4 text-align-left">
             <input type="checkbox" v-model="uploadUserListViaCSVValue">
          </div>
          <div class="col-sm-6 col-md-6 col-lg-6">
          </div>
        </div>

        <div class="row margin-top-3Perc vertical-align">
           <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
           <div class="col-sm-1 col-md-1 col-lg-1 text-align-right Padding-right-0px"> 
              <b>Users</b>
           </div>
           <div class="col-sm-9 col-md-9 col-lg-9">
             <div class="border-1px padding-15px overflow-y-enabled">
                <div class="leftAlign margin-bottom-10px" v-if="GroupUserList.length > 0 && !uploadUserListViaCSVValue">
                  <u>Total Selected {{selectedUserIds.length > 1 ? 'Users' : 'User' }}:</u> <b>{{selectedUserIds.length}}</b>
                </div>
                <div class="leftAlign" v-if="!uploadUserListViaCSVValue"> 
                  <input type="checkbox" :hidden="GroupUserList.length === 0" v-model="SelectAllUsersFlag" id="selectAllUsersCheckBox" @change="selectAllUsersChecked($event)"/>
                  <label class="font-weight-normal" for="selectAllUsersCheckBox">{{GroupUserList.length > 0 ? 'Select All' : 'No User(s)'}}</label>
                </div>  
                <div class="leftAlign" v-for="(u,index) in GroupUserList" :key="index" v-if="GroupUserList.length > 0 && !uploadUserListViaCSVValue"> 
                  <input type="checkbox" :checked="u.isSelected ? 'checked' : ''" :value="u" :id="u.UserId" :title="u.FirstName" @change="userCheckListChecked($event)"/>
                  <label class="font-weight-normal" :for="u.UserId">{{ u.FirstName }} {{ u.LastName }}</label>
                </div>
                <div class="leftAlign" v-if="GroupUserList.length > 0 && uploadUserListViaCSVValue">
                  <span><input type="file" accept=".csv" id="uploadcsvfile"></span>
                  <span>|</span>
                  <span class="padding-15px cursor-pointer text-decoration-underline text-color-blue" @click="downloadUserCSVTemplate">Download Template</span>
                </div>
             </div>
           </div>
        </div>
        <div class="row margin-top-3Perc vertical-align">
           <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
           <div class="col-sm-1 col-md-1 col-lg-1 text-align-right Padding-right-0px"><b>Sender</b></div> 
           <div class="col-sm-4 col-md-4 col-lg-4">
              <select class="form-control" v-model="selectedSenderEmail">
                 <option value='-1'  disabled>Select</option>
                 <option v-for="se in SenderEmailList" v-bind:key="se" v-bind:value="se">{{ se }}</option>             
              </select>
           </div>
           <div class="col-sm-1 col-md-1 col-lg-1 text-align-right Padding-right-0px"><b>Template</b></div> 
           <div class="col-sm-4 col-md-4 col-lg-4">
              <select class="form-control" v-model="selectedEmailTemplate" @change="emailTemplateSelected">
                 <option value='-1' disabled>Select</option>
                 <option v-for="et in EmailTemplates" v-bind:key="et.EmailTemplateId" v-bind:value="et">{{ et.EmailTemplateName }}</option>
               </select>     
           </div>
           <div class="col-sm-1 col-md-1 col-lg-1"></div>
        </div>
        <div class="row">
          <div class="col-md-7 col-lg-7"></div>
          <div class="col-md-4 col-lg-4 font-size-14Px margin-top-5px">
            <a class="cursor-pointer" @click="showAddTemplate()">New</a> |
            <a class="cursor-pointer" @click="showUpdateTemplate()">Edit</a> |
            <a class="cursor-pointer" @click="showDeleteTemplateConfirmation()">Delete</a>
          </div>
        </div>
        <div class="row margin-top-3Perc vertical-align">
           <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
              <div class="col-sm-1 col-md-1 col-lg-1 text-align-right Padding-right-0px">
                <b>Subject</b>
              </div>
              <div class="col-md-9 col-lg-9">
                 <div class="form-group">
                    <div class="col-sm-10 col-md-10 col-lg-10 text-left Padding-left-0px" :class="{'font-weight-bold': selectedEmailTemplate !== -1, 'font-weight-bold-withOpacity75': selectedEmailTemplate === -1}">
                       <!--<input type="text" placeholder="Email subject" class="form-control" :value="selectedEmailTemplate === -1 ? '' : selectedEmailTemplate.EmailSubject" disabled/> -->
                       {{selectedEmailTemplate === -1 ? 'Template Not Selected' : selectedEmailTemplate.EmailSubject}}
                    </div>
                 </div>
              </div>
        </div>
        <div class="row margin-top-3Perc">
           <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
              <div class=" col-md-1 col-lg-1 text-align-right Padding-right-0px">
                <b>Content</b>
              </div>
              <div class="col-md-9 col-lg-9">
                 <div class="form-group">
                    <div class="col-sm-12 padding-left-0Perc Padding-right-0px">
                       <!-- <vue-editor v-model="templateBodyText" :editorToolbar="customToolbar" v-if="!ShowAddTemplateOverlay && !ShowUpdateTemplateOverlay" disabled></vue-editor> -->
                       <tinymce id="d1" v-model="templateBodyText" v-if="!ShowAddTemplateOverlay && !ShowUpdateTemplateOverlay" :readonly="true"></tinymce>
                    </div>
                 </div>
              </div>
        </div>
            <div class="row margin-top-3Perc">
              <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
              <div class="col-sm-1 col-md-1 col-lg-1 text-align-right Padding-right-0px">
                <b>Attach Files</b>
              </div>
              <div class="col-sm-9 col-md-9 col-lg-9">
                 <form >
                  <div class="row ">
                     <div class="col-sm-3 col-md-3 col-lg-3">
                      <input type="file" name="file1" id='file1' accept="image/*">
                     </div>
                     <div class="col-sm-3 col-md-3 col-lg-3">
                       <input type="file" name="file2" id='file2' accept="image/*">
                     </div>
                     <div class="col-sm-3 col-md-3 col-lg-3">
                       <input type="file" name="file3" id='file3' accept="image/*">
                     </div>
                  </div>
                   
                  <div class="row margin-top-2Perc">
                     <div class="col-sm-3 col-md-3 col-lg-3">
                       <input type="file" name="file4" id='file4' accept="image/*">
                     </div>
                     <div class="col-sm-3 col-md-3 col-lg-3">
                       <input type="file" name="file5" id='file5' accept="image/*">
                     </div>
                     <div class="col-sm-3 col-md-3 col-lg-3">
                       <input type="file" name="file6" id='file6' accept="image/*">
                     </div>
                  </div>
                   <div class="row margin-top-3Perc">
                     <div class="col-sm-2 col-md-2 col-lg-2 margin-top-1Perc text-align-left">
                       <input type="checkbox" v-model="OnlyMeSelected"> Only Me<br>
                     </div> 
                     <div class="col-sm-2 col-md-2 col-lg-2 margin-top-1Perc text-align-left">
                       <input type="checkbox" v-model="SupportSelected"> Support<br>
                     </div>
                     <div class="col-sm-8 col-md-8 col-lg-8 margin-top-1Perc"></div>
                   </div>
                   <div class="row margin-top-3Perc">
                     <button type="button" class="btn btn-default button-orange col-lg-offset-4 col-lg-2" @click="sendEmail()">Send</button>
                   </div>  
                  </form>
              </div>
              <div class="col-sm-1 col-md-1 col-lg-1"></div>
            </div>

            <div class="row margin-top-3Perc vertical-align">
              <div class="col-sm-1 col-md-1 col-lg-1"></div>
              <div class="col-sm-1 col-md-1 col-lg-1 text-align-right Padding-right-0px"><b>Keywords</b></div>
              <div class="col-sm-9 col-md-9 col-lg-9 text-left">{firstname}, {lastname}, {email}, {loginid}</div>
            </div>

            <div class="row margin-top-3Perc margin-bottom-5Perc">
              <div class="col-sm-1 col-md-1 col-lg-1"></div>
              <div class="col-sm-1 col-md-1 col-lg-1 text-align-right Padding-right-0px"><b>Course Progress Keyword</b></div>
              <div class="col-sm-9 col-md-9 col-lg-9 text-left">{StartTable},{CourseImage},{CourseName:label_CourseName},
                                    {CourseProgress:label_CourseProgress},{Enrolled_On:label_EnrolledOn},
                                    {CourseEnds:label_CourseEnds},{EndTable}
                                    <br><br>
                                    Fields starting with label_ should be replaced with custom column names in the template. 
                                    For eg : <b>{CourseName:label_CourseName}</b> can be used like<b> {CourseName: Enrolled Courses}</b>, and 
                                    {CourseProgress:label_CourseProgress} can be used like <b>{CourseName:Your Progress}</b> etc.
              </div>
            </div>
    </div>
    <div class="animationload" v-show="showSpinner">
        <div class="osahanloading"></div>
    </div>
    <loader></loader>
    <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixDeleteTemplateString" v-bind:postfixString="postDeleteTemplateString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="deleteSelectedTemplate"></confirmation-alert>
    <add-template-overlay v-if="ShowAddTemplateOverlay" v-bind:templateType=1 @closeOverlay="closeTemplateOverlay"></add-template-overlay>
    <update-template-overlay v-bind:selectedTemplateObj="selectedEmailTemplate" v-if="ShowUpdateTemplateOverlay" @closeOverlay="closeTemplateOverlay" @isUpdatedTemplate="isUpdateSelectedTemplate"></update-template-overlay>       
    <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>     
    </div>
</template>

<script>
import csvHelper from '@/utils/csv-helper'
import AddTemplateOverlay from '@/components/emails/template/AddTemplateOverlay'
import UpdateTemplateOverlay from '@/components/emails/template/UpdateTemplateOverlay'
import AlertBox from '@/components/AlertOverlay'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import { constants } from '@/utils/constants'
import { VueEditor } from 'vue2-quill-editor'
import { groupService } from '@/server-util/group-service'
import { groupCourseService } from '@/server-util/group-course-service'
import { emailService } from '@/server-util/email-service'
import { templateService } from '@/server-util/template-service'
import lodash from 'lodash'
import Loader from '@/components/dashboard/Loader'
import tinymce from 'vue-tinymce-editor'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
export default {
  // created: function () {
  //   this.openAlertDialog()
  // },
  data: function () {
    return {
      uploadUserListViaCSV: false,
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      customToolbar: [],
      userList: [],
      groupList: [],
      coursesList: [],
      selectedGroupObj: -1,
      selectedCourseIds: [],
      selectedUserIds: [],
      selectedCourseObj: -1,
      senderEmails: [],
      selectedEmailTemplate: -1,
      templateBodyText: '',
      selectedSenderEmail: -1,
      selectAllCoursesFlag: false,
      selectAllUsersFlag: false,
      testEmail: '',
      testSupportEmail: '',
      testOnlyMeEmail: '',
      prefixDeleteTemplateString: 'Are you sure you want to delete ',
      postDeleteTemplateString: '',
      showConfirmationBox: false,
      showAddTemplateOverlay: false,
      showUpdateTemplateOverlay: false,
      isSupportSelected: false,
      isOnlyMeSelected: true
    }
  },
  created () {
    //  HB: Set this value to OnlyMe, as we don't want accidental emails to be sent to users
    this.testEmail = 'OnlyMe'
    this.testOnlyMeEmail = 'OnlyMe'
    this.loadSenderEmails()
    this.getEmailTemplates()
    this.getGroups()
  },
  components: {
    'alert-box': AlertBox,
    VueEditor,
    'add-template-overlay': AddTemplateOverlay,
    'update-template-overlay': UpdateTemplateOverlay,
    'confirmation-alert': ConfirmationOverlay,
    'loader': Loader,
    'tinymce': tinymce
  },
  computed: {
    uploadUserListViaCSVValue: {
      get: function () {
        return this.uploadUserListViaCSV
      },
      set: function (newValue) {
        this.uploadUserListViaCSV = newValue
      }
    },
    GroupList: {
      get: function () {
        return this.groupList
      },
      set: function (newValue) {
        this.groupList = newValue
      }
    },
    GroupUserList: {
      get: function () {
        return this.userList.filter(function (item) {
          return parseInt(item.AccountType) < parseInt(constants.UserAccountType.Coach)
        })
      },
      set: function (newValue) {
        this.userList = newValue
      }
    },
    CoursesList: {
      get: function () {
        return this.coursesList
      },
      set: function (newValue) {
        this.coursesList = newValue
      }
    },
    SenderEmailList: {
      get: function () {
        return this.senderEmails
      },
      set: function (newValue) {
        this.senderEmails = newValue
      }
    },
    SelectAllCoursesFlag2: {
      get: function () {
        return this.selectAllCoursesFlag
      },
      set: function (newValue) {
        this.selectAllCoursesFlag = newValue
      }
    },
    SelectAllUsersFlag: {
      get: function () {
        return this.selectAllUsersFlag
      },
      set: function (newValue) {
        this.selectAllUsersFlag = newValue
      }
    },
    EmailTemplates: {
      get: function () {
        return this.$store.state.progressionTemplateList
      },
      set: function (newValue) {
        this.$store.state.progressionTemplateList = newValue
      }
    },
    ShowAddTemplateOverlay: {
      get: function () {
        return this.showAddTemplateOverlay
      },
      set: function (newValue) {
        this.showAddTemplateOverlay = newValue
      }
    },
    ShowUpdateTemplateOverlay: {
      get: function () {
        return this.showUpdateTemplateOverlay
      },
      set: function (newValue) {
        this.showUpdateTemplateOverlay = newValue
      }
    },
    ShowConfirmationBox: {
      get: function () {
        return this.showConfirmationBox
      },
      set: function (newValue) {
        this.showConfirmationBox = newValue
      }
    },
    OnlyMeSelected: {
      get: function () {
        return this.isOnlyMeSelected
      },
      set: function (newValue) {
        this.isOnlyMeSelected = newValue
        if (newValue) {
          this.isSupportSelected = false
        }
      }
    },
    SupportSelected: {
      get: function () {
        return this.isSupportSelected
      },
      set: function (newValue) {
        this.isSupportSelected = newValue
        if (newValue) {
          this.isOnlyMeSelected = false
        }
      }
    }
  },
  methods: {
    openAlertDialog: function () {
      this.showAlertDialog = true
      this.errorMsg = 'Coming Soon. This feature is under construction.'
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    showAddTemplate () {
      this.ShowAddTemplateOverlay = true
      this.$store.state.isOverlayVisible = true
    },
    showUpdateTemplate () {
      if (this.selectedEmailTemplate === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a template.'
        return
      }
      this.ShowUpdateTemplateOverlay = true
      this.$store.state.isOverlayVisible = true
    },
    showDeleteTemplateConfirmation () {
      if (this.selectedEmailTemplate === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a template.'
        return
      }
      this.ShowConfirmationBox = true
      this.$store.state.isOverlayVisible = true
      this.postDeleteTemplateString = '\'' + this.selectedEmailTemplate.EmailTemplateName + '\' template?'
    },
    closeTemplateOverlay () {
      this.$store.state.isOverlayVisible = false
      if (this.ShowAddTemplateOverlay === true) {
        this.ShowAddTemplateOverlay = false
      }
      if (this.ShowUpdateTemplateOverlay === true) {
        this.ShowUpdateTemplateOverlay = false
        this.$store.state.isOverlayVisible = false
      }
      if (this.selectedEmailTemplate !== -1) {
        this.emailTemplateSelected()
      }
    },
    isUpdateSelectedTemplate (value) {
      // AK: Used to reset template filter to -1 if user updated any Template
      if (value) {
        this.selectedEmailTemplate = -1
        this.templateBodyText = ''
      }
    },
    deleteSelectedTemplate (value) {
      this.$store.state.isOverlayVisible = false
      this.showConfirmationBox = false
      // AK: Used to delete selected Template
      if (value) {
        this.deleteTemplate()
      }
    },
    deleteTemplate: function () {
      var storeObj = this.$store
      var _this = this
      if (this.selectedEmailTemplate !== -1) {
        // this.showSpinner = true
        this.$store.state.isLoading = true
        storeObj.state.progressionTemplateList = []
        templateService
          .deleteTemplate(
            storeObj.state.access_token, this.selectedEmailTemplate.EmailTemplateId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              _this.selectedEmailTemplate = -1
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              _this.clearAllFields()
              // AK: After successfully delete, get all Template list again from server
              _this.getEmailTemplates()
            } else {
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              _this.showAlertDialog = true
              _this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            _this.showAlertDialog = true
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            if (errorObj.response === undefined) {
              _this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              _this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log('TEMPLATE OBJECT IS NULL HENCE DECLINED DELETE TEMPALTE OPERATION.')
      }
    },
    updateShowConfirmationAlertFlag (value) {
      this.$store.state.isOverlayVisible = false
      // AK: Used when user pressed close button of delete element overlay
      this.showConfirmationBox = value
    },
    getGroups () {
      var store = this.$store
      var _this = this
      this.GroupList = store.state.groupList
      groupService.listGroups(store.state.access_token).then(responseObj => {
        if (responseObj.status >= 200 && responseObj.status < 300) {
          // AK: Hide Spinner
          // _this.showSpinner = false
          _this.$store.state.isLoading = false
          _this.GroupList = responseObj.data
          //  this.getGroupCourses()
          // AK: Close overlay
          _this.$emit('closeOverlay', false)
        } else {
          _this.showAlertDialog = true
          _this.errorMsg = 'Oops! Something went wrong. Please try again.'
          // AK: Hide Spinner if error occured
          // _this.showSpinner = false
          _this.$store.state.isLoading = false
        }
      }, errorObj => {
        // AK: Hide Spinner if error occured
        // _this.showSpinner = false
        _this.$store.state.isLoading = false
        _this.showAlertDialog = true
        if (errorObj.response === undefined) {
          _this.errorMsg = constants.No_Internet_Connection_Msg
        } else {
          _this.errorMsg = errorObj.response.statusText
        }
      })
    },
    getGroupCourses (selectedGroupId = '') {
      var _this = this
      var store = this.$store
      // this.showSpinner = true
      this.$store.state.isLoading = true
      groupCourseService.listGroupCoursesMaster(store.state.access_token, selectedGroupId).then(responseObj => {
        if (responseObj.status >= 200 && responseObj.status < 300) {
          // _this.showSpinner = false
          _this.$store.state.isLoading = false
          _this.CoursesList = responseObj.data
          if (_this.CoursesList.length > 0) {
            _this.CoursesList.forEach(gc => {
              gc.isSelected = false
            })
            console.log('Users in Courses ', _this.GroupUserList)
          }
          //  Close Overlay
          _this.$emit('closeOverlay', false)
        }
      }, errorObj => {
        // _this.showSpinner = false
        _this.$store.state.isLoading = false
        _this.showAlertDialog = true
        if (errorObj.response === undefined) {
          _this.errorMsg = constants.No_Internet_Connection_Msg
        } else {
          _this.errorMsg = errorObj.response.statusText
        }
      })
    },
    getUserEnrolledInGroupCourses () {
      var store = this.$store
      var _this = this
      this.GroupUserList = []
      //  this.selectedUserIds = []
      // this.showSpinner = true
      this.$store.state.isLoading = true
      // console.log('BEFORE getUserEnrolledInGroupCourses : ', this.selectedCourseIds)
      groupCourseService.getUsersInGroupCourses(store.state.access_token, this.selectedCourseIds).then(responseObj => {
        if (responseObj.status >= 200 && responseObj.status < 300) {
          // _this.showSpinner = false
          _this.$store.state.isLoading = false
          _this.GroupUserList = responseObj.data
          // AK: Close overlay
          if (_this.GroupUserList.length > 0) {
            _this.GroupUserList.forEach(gu => {
              gu.isSelected = _this.SelectAllUsersFlag
            })
            // console.log('Users in Courses ', _this.GroupUserList)
          }
          _this.$emit('closeOverlay', false)
        }
      },
      errorObj => {
        // _this.showSpinner = false
        _this.$store.state.isLoading = false
        _this.showAlertDialog = true
        if (errorObj.response === undefined) {
          _this.errorMsg = constants.No_Internet_Connection_Msg
        } else {
          _this.errorMsg = errorObj.response.statusText
        }
      })
    },
    selectGroup (evt) {
      // console.log('SOME LOG ', evt)
      // console.log('Selected Group ', this.selectedGroupObj)
      if (this.selectedGroupObj !== null) {
        this.selectedCourseIds = []
        this.CoursesList = []
        this.GroupUserList = []
        this.selectedUserIds = []
        this.SelectAllCoursesFlag2 = false
        this.SelectAllUsersFlag = false
        this.getGroupCourses(this.selectedGroupObj.GroupId)
      }
      //  evt.srcElement.value
    },
    loadSenderEmails () {
      var store = this.$store
      var token = store.state.access_token
      var _this = this

      emailService.getSenderEmailList(token).then(responseObj => {
        if (responseObj.status >= 200 && responseObj.status < 300) {
          // _this.showSpinner = false
          _this.$store.state.isLoading = false
          _this.SenderEmailList = responseObj.data
          // AK: Close overlay
          _this.$emit('closeOverlay', false)
        }
      }, errorObj => {
        // _this.showSpinner = false
        _this.$store.state.isLoading = false
        _this.showAlertDialog = true
        if (errorObj.response === undefined) {
          _this.errorMsg = constants.No_Internet_Connection_Msg
        } else {
          _this.errorMsg = errorObj.response.statusText
        }
      })
    },
    selectAllCoursesChecked (evt) {
      // console.log('selectAllCoursesChecked CHECK LIST ', evt)
      // console.log('selectAllUsersChecked CHECK LIST ', evt)
      if (this.selectedGroupObj === -1) {
        this.errorMsg = 'Please select a valid group.'
        this.showAlertDialog = true
        this.SelectAllUsersFlag = false
        this.SelectAllCoursesFlag2 = false
        return
      }
      if (this.CoursesList.length === 0) {
        this.errorMsg = 'Select group doesn\'t have any courses associated with it.'
        this.showAlertDialog = true
        this.SelectAllUsersFlag = false
        this.SelectAllCoursesFlag2 = false
        return
      }
      this.selectedCourseIds = []
      for (var i = 0; i < this.CoursesList.length; i++) {
        var currCourse = this.CoursesList[i]
        if (evt.target.checked) {
          this.SelectAllCoursesFlag2 = true
          this.CoursesList[i].isSelected = true
          this.SelectAllUsersFlag = false
          this.addCourseMasterId(currCourse.GroupCourseMasterId)
        } else {
          this.SelectAllCoursesFlag2 = false
          this.SelectAllUsersFlag = false
          this.CoursesList[i].isSelected = false
          this.selectedUserIds = []
          this.removeCourseMasterId(currCourse.GroupCourseMasterId)
        }
      }
      if (evt.target.checked) {
        this.getUserEnrolledInGroupCourses()
      } else {
        this.GroupUserList = []
      }
    },
    selectAllUsersChecked (evt) {
      // console.log('selectAllUsersChecked CHECK LIST ', evt)
      if (this.selectedGroupObj === -1) {
        this.errorMsg = 'Please select a valid group.'
        this.showAlertDialog = true
        this.SelectAllUsersFlag = false
        return
      }
      if (this.CoursesList.length === 0) {
        this.errorMsg = 'Select group doesn\'t have any course associated with it.'
        this.showAlertDialog = true
        this.SelectAllUsersFlag = false
        return
      }
      if (this.GroupUserList.length === 0) {
        this.errorMsg = 'No user is enrolled for select course.'
        this.showAlertDialog = true
        this.SelectAllUsersFlag = false
        return
      }
      for (var i = 0; i < this.GroupUserList.length; i++) {
        var currUser = this.GroupUserList[i]
        if (evt.target.checked) {
          this.addUserId(currUser.UserId)
          this.setUserSelectedFlag(currUser.UserId, true)
        } else {
          this.removeUserId(currUser.UserId)
          this.setUserSelectedFlag(currUser.UserId, false)
        }
      }
      if (evt.target.checked) {
        this.SelectAllUsersFlag = true
      } else {
        this.SelectAllUsersFlag = false
      }
    },
    courseCheckListChecked (evt) {
      // console.log('Course CHECK LIST ', evt)
      // console.log('Course CHECK LIST ', evt.target)
      // console.log('Course CHECK LIST ', evt.target.id)
      // console.log(' Course CHECK LIST  CHECKED', evt.target.checked)
      if (evt.target.checked) {
        // console.log('CHECKED TRUE')
        this.addCourseMasterId(evt.target.id)
        this.setCourseSelectedFlag(evt.target.id, true)
      } else {
        // console.log('CHECKED FALSE')
        this.SelectAllCoursesFlag2 = false
        this.SelectAllUsersFlag = false
        this.removeCourseMasterId(evt.target.id)
        this.setCourseSelectedFlag(evt.target.id, false)
        this.selectedUserIds = []
      }
    },
    setCourseSelectedFlag (gcmId, flag) {
      lodash.forEach(this.CoursesList, function (o) {
        if (o.GroupCourseMasterId === gcmId) {
          o.isSelected = flag
        }
      })
    },
    setUserSelectedFlag (userId, flag) {
      lodash.forEach(this.GroupUserList, function (o) {
        if (o.UserId === userId) {
          o.isSelected = flag
        }
      })
    },
    addCourseMasterId (gcmId) {
      if (this.selectedCourseIds.length > 0) {
        for (var i = 0; i < this.selectedCourseIds.length; i++) {
          if (this.checkIfCourseIdExists(gcmId) === false) {
            this.selectedCourseIds.push(gcmId)
            break
          }
        }
      } else {
        this.selectedCourseIds.push(gcmId)
      }
      if (this.SelectAllCoursesFlag2 === true) {
        //  this.getUserEnrolledInGroupCourses()
      } else {
        if (this.selectedCourseIds.length === this.CoursesList.length) {
          this.SelectAllCoursesFlag2 = true
        } else {
          this.SelectAllCoursesFlag2 = false
        }
        this.getUserEnrolledInGroupCourses()
      }
    },
    removeCourseMasterId (gcmId) {
      //  var _this = this
      if (this.selectedCourseIds.length > 0) {
        // console.log('BEFORE REMOVAL -- ', this.selectedCourseIds)
        const index = lodash.findIndex(this.CoursesList, {'GroupCourseMasterId': gcmId})
        if (index > -1) {
          this.CoursesList[index].isSelected = false
        }
        for (var i = 0; i < this.selectedCourseIds.length; i++) {
          if (this.checkIfCourseIdExists(gcmId) === true) {
            //  lodash.pull(this.selectedCourseIds, gcmId)
            lodash.remove(this.selectedCourseIds, function (id) {
              return id === gcmId
            })
            // console.log('AFTER REMOVAL -- ', this.selectedCourseIds)
            if (this.selectedCourseIds.length > 0) {
              this.selectAllCoursesFlag = false
              this.getUserEnrolledInGroupCourses()
            } else {
              this.selectedCourseIds = []
              this.GroupUserList = []
            }
            break
          }
        }
      } else {
        this.GroupUserList = []
        this.selectedUserIds = []
        this.selectedCourseIds = []
      }
    },
    checkIfCourseIdExists (gcmId) {
      var flag = false
      for (var ii = 0; ii < this.selectedCourseIds.length; ii++) {
        var currId = this.selectedCourseIds[ii]
        if (currId === gcmId) {
          flag = true
          break
        }
      }
      return flag
    },
    userCheckListChecked (evt) {
      // console.log('User CHECK LIST ', evt)
      if (evt.target.checked) {
        // console.log('CHECKED TRUE')
        this.addUserId(evt.target.id)
        this.setUserSelectedFlag(evt.target.id, true)
      } else {
        // console.log('CHECKED FALSE')
        this.SelectAllUsersFlag = false
        this.removeUserId(evt.target.id)
        this.setUserSelectedFlag(evt.target.id, false)
      }
    },
    addUserId (userId) {
      if (this.selectedUserIds.length > 0) {
        for (var i = 0; i < this.selectedUserIds.length; i++) {
          if (this.checkIfUserIdExists(userId) === false) {
            this.selectedUserIds.push(userId)
            break
          }
        }
        if (this.selectedUserIds.length === this.GroupUserList.length) {
          this.SelectAllUsersFlag = true
        } else {
          this.SelectAllUsersFlag = false
        }
      } else {
        this.selectedUserIds.push(userId)
        if (this.selectedUserIds.length === this.GroupUserList.length) {
          this.SelectAllUsersFlag = true
        } else {
          this.SelectAllUsersFlag = false
        }
      }
      // console.log('AFTER ADDING USERID', this.selectedUserIds)
    },
    checkIfUserIdExists (userId) {
      var flag = false
      for (var ii = 0; ii < this.selectedUserIds.length; ii++) {
        var currId = this.selectedUserIds[ii]
        if (currId === userId) {
          flag = true
          break
        }
      }
      return flag
    },
    removeUserId (userId) {
      if (this.selectedUserIds.length > 0) {
        // console.log('BEFORE REMOVAL -- ', this.selectedUserIds)
        for (var i = 0; i < this.selectedUserIds.length; i++) {
          if (this.checkIfUserIdExists(userId) === true) {
            lodash.remove(this.selectedUserIds, function (id) {
              return id === userId
            })
            //  lodash.remove(this.selectedUserIds, [userId], lodash.isEqual)
            // console.log('AFTER REMOVAL -- ', this.selectedUserIds)
            this.SelectAllUsersFlag = false
            break
          }
        }
      }
    },
    getEmailTemplates () {
      var store = this.$store
      var _this = this
      var token = store.state.access_token

      store.state.progressionTemplateList = []
      emailService.getTemplateList(token, constants.EmailTemplateType.Progression).then(responseObj => {
        if (responseObj.status >= 200 && responseObj.status < 300) {
          // _this.showSpinner = false
          _this.$store.state.isLoading = false
          store.state.progressionTemplateList = responseObj.data
          _this.EmailTemplates = store.state.progressionTemplateList
          // AK: Close overlay
          _this.$emit('closeOverlay', false)
        }
      }, errorObj => {
        // _this.showSpinner = false
        _this.$store.state.isLoading = false
        this.showAlertDialog = true
        if (errorObj.response === undefined) {
          this.errorMsg = constants.No_Internet_Connection_Msg
        } else {
          this.errorMsg = errorObj.response.statusText
        }
      })
    },
    emailTemplateSelected: function () {
      // console.log('Selected Template : ', this.selectedEmailTemplate)
      // this.templateBodyText = this.selectedEmailTemplate.EmailTemplateText

      var store = this.$store
      var token = store.state.access_token
      emailService.getTemplateText(token, this.selectedEmailTemplate.EmailTemplateId).then(responseObj => {
        if (responseObj.status >= 200 && responseObj.status < 300) {
          // this.showSpinner = false
          this.$store.state.isLoading = false
          this.templateBodyText = responseObj.data.EmailTemplateText
          const orgContent = dmAdminUtils.removeTFromUrls(this.templateBodyText)
          this.templateBodyText = orgContent
          this.selectedEmailTemplate.EmailTemplateText = responseObj.data.EmailTemplateText

          const index = lodash.findIndex(this.EmailTemplates, {EmailTemplateId: this.selectedEmailTemplate.EmailTemplateId})
          if (index) {
            this.EmailTemplates[index].EmailTemplateText = responseObj.data.EmailTemplateText
          }
        }
      }, errorObj => {
        // this.showSpinner = false
        this.$store.state.isLoading = false
        this.showAlertDialog = true
        if (errorObj.response === undefined) {
          this.errorMsg = constants.No_Internet_Connection_Msg
        } else {
          this.errorMsg = errorObj.response.statusText
        }
      })
    },
    checkCSVFileExtesion: function (fileName) {
      var exts = ['.csv', '.CSV']
      return new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$').test(
        fileName
      )
    },
    sendEmail () {
      if (this.selectedGroupObj === -1 || this.selectedGroupObj === null || this.selectedGroupObj === undefined) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a group.'
        return
      }
      if (this.selectedCourseIds.length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a course.'
        return
      }

      if (this.uploadUserListViaCSVValue) {
        var fileUrl = document.getElementById('uploadcsvfile').files[0]
        if (fileUrl !== undefined) {
          if (!this.checkCSVFileExtesion(document.getElementById('uploadcsvfile').value)) {
            this.showAlertDialog = true
            this.errorMsg = 'Invalid file format detected.'
            return
          }
        } else {
          this.showAlertDialog = true
          this.errorMsg = 'Please select a .csv file.'
          return
        }
      } else {
        if (this.selectedUserIds.length === 0) {
          this.showAlertDialog = true
          this.errorMsg = 'Please select at least one participant.'
          return
        }
      }
      if (this.selectedSenderEmail === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a sender email.'
        return
      }
      if (this.selectedEmailTemplate === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select an email template.'
        return
      }
      var courseMasterIds = []
      var _this = this
      var store = this.$store
      var token = store.state.access_token
      for (var i = 0; i < this.selectedCourseIds.length; i++) {
        var gcmId = this.selectedCourseIds[i]
        var courseObj = lodash.find(this.CoursesList, function (o) { return o.GroupCourseMasterId === gcmId })
        if (courseObj !== undefined && courseObj !== null) {
          courseMasterIds.push(courseObj.CourseMasterId)
        }
      }

      let testEmail = ''
      if (this.OnlyMeSelected) {
        testEmail = 'onlyme'
      } else if (this.SupportSelected) {
        testEmail = 'support'
      }
      // console.log('testEmail: ' + testEmail)

      const formData = new FormData()
      // console.log('UserIDs ', this.selectedUserIds.toString())
      // console.log('CourseMasterIds ', courseMasterIds.toString())
      formData.append('GroupId', this.selectedGroupObj.GroupId)
      formData.append('EmailTemplateId', this.selectedEmailTemplate.EmailTemplateId)
      if (!this.uploadUserListViaCSVValue) {
        formData.append('UserCSV', null)
        formData.append('ToUserIds', this.selectedUserIds.toString())
      } else {
        fileUrl = document.getElementById('uploadcsvfile').files[0]
        formData.append('UserCSV', fileUrl)
        formData.append('ToUserIds', null)
      }
      formData.append('SenderEmail', this.selectedSenderEmail.toString())
      formData.append('CourseMasterIds', courseMasterIds.toString())
      formData.append('EmailSubject', this.selectedEmailTemplate.EmailSubject)
      formData.append('TestEmail', testEmail)
      formData.append('EmailTemplateText', this.templateBodyText)

      var file1 = document.getElementById('file1').files[0]
      var file2 = document.getElementById('file2').files[0]
      var file3 = document.getElementById('file3').files[0]
      var file4 = document.getElementById('file4').files[0]
      var file5 = document.getElementById('file5').files[0]
      var file6 = document.getElementById('file6').files[0]
      if (file1 !== undefined) {
        formData.append('file1', file1)
      }
      if (file2 !== undefined) {
        formData.append('file2', file2)
      }
      if (file3 !== undefined) {
        formData.append('file3', file3)
      }
      if (file4 !== undefined) {
        formData.append('file4', file4)
      }
      if (file5 !== undefined) {
        formData.append('file5', file5)
      }
      if (file6 !== undefined) {
        formData.append('file6', file6)
      }
      // console.log('Mail to be sent to users : ' + this.selectedUserIds)
      // this.showSpinner = true
      this.$store.state.isLoading = true
      emailService.sendProgressionMail(token, formData).then(responseObj => {
        if (responseObj.status >= 200 && responseObj.status < 300) {
          // _this.showSpinner = false
          _this.$store.state.isLoading = false
          _this.showAlertDialog = true
          _this.errorMsg = 'Total Users: <b>' + responseObj.data.TotalUsers + '</b><br/>' + 'Total Emails Sent: <b>' + responseObj.data.TotalEmailsSent + '</b><br/>' + 'Total Emails Failed: <b>' + responseObj.data.TotalEmailsFailed + '</b>'
          if (responseObj.data.FailedEmailList.length > 0) {
            _this.errorMsg += '<br/>Failed Emails:<br/>'
            lodash.forEach(responseObj.data.FailedEmailList, (currObj, index) => {
              // _this.errorMsg += '<tr><td>' + (index + 1) + '</td><td>' + (currObj.Email) + '</td><td>' + (currObj.Reason) + '</td></tr>'
              _this.errorMsg += '<span>' + (index + 1) + '. ' + currObj.Email + ' [' + currObj.Reason + ']</span><br/>'
            })
          }
          // AK: Close overlay
          _this.$emit('closeOverlay', false)
          _this.clearAllFields()
        } else {
          _this.showAlertDialog = true
          _this.errorMsg = 'Oops! Something went wrong. Please try again.'
          // AK: Hide Spinner if error occured
          // _this.showSpinner = false
          _this.$store.state.isLoading = false
        }
      }, errorObj => {
        // _this.showSpinner = false
        _this.$store.state.isLoading = false
        this.showAlertDialog = true
        if (errorObj.response === undefined) {
          this.errorMsg = constants.No_Internet_Connection_Msg
        } else {
          this.errorMsg = errorObj.response.statusText
        }
      })
    },
    downloadUserCSVTemplate: function () {
      // AK: Used to download CSV file
      var columnAlias = ['Email']
      var columnRespKey = ['']
      return csvHelper.export(null, columnRespKey, columnAlias, 'ProgressionEmailUserListTemplate')
    },
    clearAllFields () {
      this.userList = []
      this.groupList = []
      this.coursesList = []
      this.EmailTemplates = []
      this.selectedGroupObj = -1
      this.selectedCourseIds = []
      this.selectedUserIds = []
      this.selectedCourseObj = -1
      this.senderEmails = []
      this.selectedEmailTemplate = -1
      this.templateBodyText = ''
      this.selectedSenderEmail = -1
      this.selectAllCoursesFlag = false
      this.selectAllUsersFlag = false
      this.testEmail = ''
      this.testSupportEmail = ''
      this.testOnlyMeEmail = ''
      this.isSupportSelected = false
      this.isOnlyMeSelected = true
      this.uploadUserListViaCSVValue = false
      document.getElementById('uploadcsvfile').value = ''
      document.getElementById('file1').value = ''
      document.getElementById('file2').value = ''
      document.getElementById('file3').value = ''
      document.getElementById('file4').value = ''
      document.getElementById('file5').value = ''
      document.getElementById('file6').value = ''
      this.testEmail = 'OnlyMe'
      this.testOnlyMeEmail = 'OnlyMe'
      this.loadSenderEmails()
      this.getEmailTemplates()
      this.getGroups()
    }
  },
  name: 'progressionEmailComponent'
}
</script>

<style scoped>
#uploadcsvfile {
  display: inline;
}
.text-decoration-underline {
  text-decoration: underline;
}
.text-color-blue {
  color: blue;
}
.margin-bottom-10px {
  margin-bottom: 10px;
}
.progressionEmailComponent {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.overflow-y-enabled{
  overflow-y: auto
}
.leftAlign{
  text-align: left;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}

.icon-addon {
  position: relative;
  color: #555;
  display: block;
}

.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}

.icon-addon:after {
  clear: both;
}

.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}

.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 10px 16px 10px 40px;
}

.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}

.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}

.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}

.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
.border-color-red {
  border: 1px solid red;
}
.border-color-green {
  border: 1px solid green;
}
.width-70Perc {
  width: 70%;
}
.width-90Perc {
  width: 90%;
}
.text-align-left {
  text-align: left !important;
}
.Padding-left-0px {
  padding-left: 0px !important;
}
.font-size-18px {
  font-size: 18px;
}
.margin-top-1Perc {
  margin-top: 1%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.background-gray {
  background-color: #ddd;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.gray-border {
  border: 1px solid #aaa;
}
.white-BG {
  background-color: #ffffff;
}
.margin-top-3Perc {
  margin-top: 3%;
}
.margin-top-1perc {
  margin-top: 1%;
}
.right-border-color {
  /*border-right: 1px solid #43495e;*/
}
.vertical-align {
  display: flex;
  align-items: center;
}
.width-1Perc {
  width: 1% !important;
}
.cursor-pointer {
  cursor: pointer;
}
.width-9-Perc {
  width: 9% !important;
}
@media (max-width: 1024px) {
  .width-9-Perc {
    width: 11.5% !important;
  }
}
.font-weight-bold {
  font-weight: bold;
}
.font-weight-bold-withOpacity75 {
  font-weight: bold;
  opacity: .75;
}

.font-size-15px {
  font-size: 15px;
}
.alignCenter{
  align: center;
}
.margin-0-auto{
  margin: 0 auto !important;
}
.border-color-yellow{
  border:1px solid yellow;
}
.align-center{
  align:center !important;
}
.demo-margin-left-1Perc{
  margin-left:1% !important;
}
.border-grey{
  border:1px solid grey;
}
.padding-left-1Perc{
  padding-left:1%;
}
.padding-left-12Perc{
  padding-left:12%;
}
.border-1px{
  border: 1px solid #ccc;
}
.padding-15px{
  padding:15px;
}
.width-90Perc{
  width: 90% !important;
}
.margin-bottom-7Perc{
  margin-bottom: 7%;
}
.margin-bottom-5Perc{
  margin-bottom: 5%;
}
.text-align-right{
text-align: right;
}
.padding-left-0Perc{
 padding-left:0%; 
}
.button-orange{
    background-color: #f39c12 !important;
    border: 1px solid #f39c12 !important;
}
.padding-top-7px{
  padding-top: 7px;
}
.floatLeft {
  float: left;
}
.cursor-pointer{
  cursor: pointer;
}
.padding-top-10px {
  padding-top: 10px;
}
.font-weight-normal {
  font-weight: normal
}
.Padding-right-0px {
  padding-right: 0px !important;
}
a:link{
  color: #2c3e50 !important;
  text-decoration: none !important;
} 
a:visited{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:hover{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:active{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a{
  color: #2c3e50 !important;
}
.text-align-left{
    text-align: left !important;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.margin-top-5px{
  margin-top: 5px;
}
.border-red {
  border: 1px solid red;
}
</style>



// WEBPACK FOOTER //
// src/components/emails/progression_emails/SendProgressionEmail.vue